import axios from "axios";

const api = axios.create({
  baseURL: "https://api.m3campus.com",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
